import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AboutExpertise from './pages/about-expertise';
import NetworkAssessmentTool from './pages/network-assessment-tool';
import GetQuoteConsultation from './pages/get-quote-consultation';
import CopperToFiberConversionService from './pages/copper-to-fiber-conversion-service';
import ServiceAreasLocalTeams from './pages/service-areas-local-teams';
import Homepage from './pages/homepage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/about-expertise" element={<AboutExpertise />} />
        <Route path="/network-assessment-tool" element={<NetworkAssessmentTool />} />
        <Route path="/get-quote-consultation" element={<GetQuoteConsultation />} />
        <Route path="/copper-to-fiber-conversion-service" element={<CopperToFiberConversionService />} />
        <Route path="/service-areas-local-teams" element={<ServiceAreasLocalTeams />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
